var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pvp-modal',{attrs:{"value":_vm.showAdditionalRegistration,"width":"500"},on:{"input":_vm.closeModal}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v(_vm._s(_vm.$t('profile.creation')))]),_c('create-profile-form',{on:{"registered":_vm.onRegistered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }